export default {
    mapLandmarkCreateEditLandmarkGroup_editTitle: "Editar Grupo de Puntos de Referencia: ",
    mapLandmarkCreateEditLandmarkGroup_createTitle: "Crear Nuevo Grupo de Puntos de Referencia",
    mapLandmarkCreateEditLandmarkGroup_name: "Nombre",
    mapLandmarkCreateEditLandmarkGroup_landmarkIcon: "Ícono de Grupo Puntos de Referencia",
    mapLandmarkCreateEditLandmarkGroup_success: "Grupo de Puntos de Referencia guardado",
    mapLandmarkCreateEditLandmarkGroup_iconRequired: 'Debe seleccionar un ícono o deshabilitar el switch de "Ícono de Grupo Puntos de Referencia", por favor intente de nuevo',
    mapLandmarkCreateEditLandmarkGroup_groupAlreadyExists: "Ya existe un grupo con el nombre ingresado"
};